import type { Me } from "../../src/web/types.ts";

// Who I am, as the page draws from it (GET /api/me), whole whatever came (features/opening.md, "A page survives a
// deploy under it"): every page reads it (getting started reads `ais` before anything is drawn), so a field missing
// from the answer (one kept on the phone from an older Tripmo, or a newer field an older one never sent) is filled in
// with its none, never left for a page to crash on. Without me in it (no `user` with an id), it isn't an answer about
// me at all: null, for the caller to refuse as Tripmo not answering.
const DEFAULT_GLYPHS = "/glyphs/{fontstack}/{range}.pbf";

// This page's origin (none outside a browser, as in the unit tests).
const here = () => (globalThis as { location?: { origin: string } }).location?.origin ?? "";
const list = <T>(value: unknown): T[] => (Array.isArray(value) ? (value as T[]) : []);
const text = (value: unknown, none: string): string => (typeof value === "string" ? value : none);
const textOrNull = (value: unknown): string | null => (typeof value === "string" ? value : null);

export function meOf(answer: unknown): Me | null {
  const got = (typeof answer === "object" && answer !== null ? answer : {}) as Record<string, unknown>;
  const user = (typeof got["user"] === "object" && got["user"] !== null ? got["user"] : {}) as Record<string, unknown>;
  if (typeof user["id"] !== "string" || !user["id"]) return null;
  const map = (typeof got["map"] === "object" && got["map"] !== null ? got["map"] : {}) as Record<string, unknown>;
  return {
    user: {
      id: user["id"],
      name: text(user["name"], ""),
      email: text(user["email"], ""),
      photo: textOrNull(user["photo"]),
      color: (textOrNull(user["color"]) as Me["user"]["color"]) ?? null,
    },
    mcp_url: text(got["mcp_url"], `${here()}/mcp`),
    // No base map named: the map's own paper (no tiles), its lettering from Tripmo.
    map: { tiles: text(map["tiles"], ""), glyphs: text(map["glyphs"], DEFAULT_GLYPHS) },
    ais: list(got["ais"]),
    tips_seen: list(got["tips_seen"]),
    time_zone: textOrNull(got["time_zone"]),
    ...("currency" in got ? { currency: textOrNull(got["currency"]) } : {}),
  };
}
